import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_6 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { id: "transactionsTable" }
const _hoisted_25 = {
  class: "text-center",
  id: "title"
}
const _hoisted_26 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_27 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_28 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_29 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_30 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_31 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_32 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = { key: 5 }
const _hoisted_47 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_48 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-header" }
const _hoisted_52 = { class: "modal-title fs-5" }
const _hoisted_53 = { class: "modal-body" }
const _hoisted_54 = { style: {} }
const _hoisted_55 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_56 = {
  key: 1,
  class: "text-success fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_59 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_60 = { class: "modal-footer" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_63 = { style: {"color":"#FFF"} }
const _hoisted_64 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_65 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = { class: "modal-header" }
const _hoisted_68 = { class: "modal-title fs-5" }
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-md-6" }
const _hoisted_73 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_84 = { class: "col-md-6" }
const _hoisted_85 = { class: "d-block text-black fw-semibold mb-10" }

import {ref, onMounted,onBeforeMount,inject  } from "vue";
import { useRoute} from 'vue-router'
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import LeadscontentPdf from "./LeadsContentPdf.vue";
import router from '../../../router/index'
import conf from '../../../../env.json'
import { useI18n } from "vue-i18n";
import {current_permissions} from '../../../utils/permission';
import{showToast,checkSessionValidate} from '../../../utils/function'
import TransactionRepository from '../../../repositories/TransactionRepository'
import { Business,Transaction } from "@/utils/Model";
declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,    
  email: string,
  created_at: string
  }

  declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,    
  countryCode: string  
  }
const leadPlaceholder = "Select date";



export default /*@__PURE__*/_defineComponent({
  __name: 'ValidationTwoTransfertContent',
  setup(__props) {


const backApi=inject('back');
let role: string|null = localStorage.getItem('role');

  const { t } = useI18n();
let url = '';
if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
  url = backApi + '/secure/transactions/extended';
} else {
  url = backApi + '/secure/transactions';
}

let data = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const loader = ref(false);
const page = ref(1);
const total = ref(0);
//const pageServ = ref('');
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const amount = ref(0);
const operator = ref('');
const paymentStatus = ref(''); 
const status = ref(''); 
const message = ref(''); 
const payoutIdLink = ref('');
const btnLoad = ref(true);
const errors = ref('');
const errorId = ref('');

    
const transactions =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);

let transactionId:string|null;
let idType:string|null;

  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

const cancel = () =>{
  status.value="";
  errorId.value="";
  errors.value="";
  payoutIdLink.value="";
}

function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}
    
let datab ='' ;
onMounted(() => {
  checkSessionValidate(1)
 
   getTransactions();
  setTimeout(function () {
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

 

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });

});
const token =  localStorage.getItem('login_token');
const loadTransaction = (code)=>{
  
  axios.get(`${url}/${code}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        transaction.value = response.data;  
        operator.value=  response.data.operator?.mnoName;
        amount.value= response.data.amount.toLocaleString();
       
         if(response.data.paymentStatus==='SUCCEEDED'){
          paymentStatus.value = "SUCCESS"
         }else if(response.data.paymentStatus==='PROCESSING'){
          paymentStatus.value = "EN COURS"
         }else if(response.data.paymentStatus==='PENDING'){
          paymentStatus.value = "EN ATTENTE"
         }else if(response.data.paymentStatus==='INITIATED'){
          paymentStatus.value = "INITIÉ"
         }else if(response.data.paymentStatus==='SCHEDULED'){
          paymentStatus.value = "PLANIFIÉ"
         }else{
          paymentStatus.value = "ECHEC"
         }   
         
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });
}

const getTransactionsOld = async () =>{
   loader.value=false;
   let data = await TransactionRepository.getRecords({publicTokenValidationStatus:'VALIDATED',validationStatus:'DRAFT'});  
   if(Array.isArray(data.transactions)){    
    transactions.value = data?.transactions;
   }else{
    // alert(data?.error)
   }
   loader.value=true;  
}

const getTransactions = (arg=1) =>{
    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;

    axios.get(`${url}?publicTokenValidationStatus=VALIDATED&validationStatus=DRAFT`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        transactions.value = response.data.data;  
       
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });

}
const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{  
      headers: {
           
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {
        // users.value = response.data;
        organizations.value = response.data;         
        console.log(response.data);
        
        
    }).catch((error) => {
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/')
              }   
              
          }
   });
  //  loader.value=true;
}
const getOperators = () =>{

axios.get(backApi+'/public/operators/',{  //secure
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    operatorsTemp = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data);
          if(error.response.status === 401){
            router.push('/')
            
          }   
          
      }
});
//  loader.value=true;
}

const exportExcelReport = (labels,fields,filename) =>{
  
  import("../../../utils/Export2Excel").then((excel)=>{
 
    const dataForExcel= formatJSon(fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:labels,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:filename,      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}



const exportExcel = () =>{
  
  import("../../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE TRANSACTION","OPERATEUR","TELEPHONE","MONTANT","DATE","STATUT"];
    const Fields = ["payoutId","operator_name","contact","amount","transactionDate","paymentStatus"];//mnoName
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"transactions",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}


function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


//[top, left, bottom, right]
const searchTransaction = (arg=1)=>{
  loader.value=false;
  gettran.value = false;
  search.value = true;
  search1.value = false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.get(`${url}?page=${arg}&dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        transactions.value = response.data.data; 
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });
}
const searchTransaction1 = (event,arg=1)=>{  
   if(typeof event.target.value!=='undefined'){
    today.value = event.target.value 
   }  
  
    // alert(today.value)  
    loader.value=false;
    gettran.value = false;
    search.value = false;
    search1.value = true;

    const todayE =  formatDateEn(new Date(today.value),1);   
  axios.get(`${url}?page=${arg}&dateD=${today.value}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.data;  
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}

const searchTransactionForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
  // if(selectedOrganization.value===''){
  //   selectedOrganization.value = "" ; 
  // }
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.get(`${backApi}/secure/transactions/list/export?dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        // transactions.value = response.data.transactions;  //.data.users 
        if(response.status === 200){  
        data  = response.data;  
        // console.log(data)
        
        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator?.mnoName;
        }  
        exportExcel()  
        //  console.log(data);
        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const reportForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
  // alert(selectedOrganization.value);
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.post(`${backApi}/secure/organizations/report`,
       {          
         start:beginDate.value,
         end:todayE,
          organization:selectedOrganization.value          
        },
        {
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {        
        if(response.status === 200){  
        data  = response.data.transactions;  
        // const dataTemp  = response.data; 
        console.log(data)
        
        for (let pas = 0; pas < data.length; pas++) {
          // data[pas].operator_name = data[pas].operator.mnoName;
          data[pas].operationType = (data[pas].operationType=="1")?"Payin":"Payout";
          data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));        
        }  
        
        const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
        const Fields = ["payoutId","transactionDate","status","amount","operationType","","paymentStatus"];

        exportExcelReport(Header,Fields,"report"); 
        //  console.log(data);
        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const showScreen = (statut,msg,payoutId)=>{ 
  status.value=statut;
  message.value=msg;
  payoutIdLink.value = payoutId;
}

const storeValidationLink = async()=>{
  loader.value=false;
  const param = {transactionId:payoutIdLink.value,idType:'payoutId',status:status.value }  
  let data = await TransactionRepository.validate_payout_two(param);
  if(data.status === 201){  
          document.getElementById("close").click();
          showToast("Lien validé avec succès","green");
          status.value='';
          payoutIdLink.value='';
          setTimeout(() => {
            router.push('/transferts/validation/two'); 
            }, 3000);          
           
  }
  loader.value=true;


}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
            _createElementVNode("div", { class: "d-sm-flex align-items-center" }),
            _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" })
              ])
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('linkValidationLevel2.code')), 1),
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('linkValidationLevel2.beneficiary')), 1),
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('linkValidationLevel2.operator')), 1),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('linkValidationLevel2.phone')), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('linkValidationLevel2.amount')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('linkValidationLevel2.date')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('linkValidationLevel2.actions')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: transaction.payoutId
                    }, [
                      _createElementVNode("th", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(transaction.payoutId), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(transaction?.clientId), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(transaction.operator?.mnoName), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(transaction?.contact), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(transaction.amount.toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(formatDateFr(new Date(transaction.transactionDate))), 1),
                      _createElementVNode("td", _hoisted_21, [
                        (_unref(current_permissions)('validate_public_token'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                              type: "button",
                              style: {"background-color":"#EB9355"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#filterLeadModal",
                              onClick: ($event: any) => (showScreen('REJECTED','Voulez-vous vraiment annuler ce lien ?',transaction?.payoutId))
                            }, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "flaticon-close-1 position-relative ms-5 top-2 fs-15" }, null, -1)
                            ]))], 8, _hoisted_22))
                          : _createCommentVNode("", true),
                        _cache[12] || (_cache[12] = _createTextVNode("       ", -1)),
                        (_unref(current_permissions)('validate_public_token'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                              type: "button",
                              style: {"background-color":"#EB9355"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#filterLeadModal",
                              onClick: ($event: any) => (showScreen('VALIDATED','Voulez-vous vraiment valider ce lien ?',transaction?.payoutId))
                            }, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("i", { class: "flaticon-draw-check-mark position-relative ms-5 top-2 fs-15" }, null, -1)
                            ]))], 8, _hoisted_23))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t('linkValidationLevel2.listTitle')), 1),
                _createElementVNode("table", _hoisted_26, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('linkValidationLevel2.code')), 1),
                      _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('linkValidationLevel2.operator')), 1),
                      _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('linkValidationLevel2.phone')), 1),
                      _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('linkValidationLevel2.amount')), 1),
                      _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('linkValidationLevel2.date')), 1),
                      _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('linkValidationLevel2.status')), 1),
                      _cache[13] || (_cache[13] = _createElementVNode("th", {
                        scope: "col",
                        class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                      }, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: transaction.payoutId
                      }, [
                        _createElementVNode("th", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, _toDisplayString(transaction.payoutId), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(transaction.operator?.mnoName), 1),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(transaction?.contact), 1),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(transaction.amount.toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_39, _toDisplayString(formatDateFr(new Date(transaction.transactionDate))), 1),
                        _createElementVNode("td", _hoisted_40, [
                          (transaction.paymentStatus==='SUCCEEDED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('linkValidationLevel2.success')), 1))
                            : _createCommentVNode("", true),
                          (transaction.paymentStatus==='FAILED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t('linkValidationLevel2.failed')), 1))
                            : _createCommentVNode("", true),
                          (transaction.paymentStatus==='PROCESSING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('linkValidationLevel2.processing')), 1))
                            : _createCommentVNode("", true),
                          (transaction.paymentStatus==='PENDING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('linkValidationLevel2.pending')), 1))
                            : _createCommentVNode("", true),
                          (transaction.paymentStatus==='INITIATED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t('linkValidationLevel2.initiated')), 1))
                            : _createCommentVNode("", true),
                          (transaction.paymentStatus==='SCHEDULED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.$t('linkValidationLevel2.scheduled')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            (total.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("h1", _hoisted_52, _toDisplayString(_ctx.$t('linkValidationLevel2.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              id: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              (status.value=='REJECTED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_55, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true),
              (status.value=='VALIDATED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_56, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("h6", _hoisted_58, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_59, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('linkValidationLevel2.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (storeValidationLink()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_62))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('linkValidationLevel2.yes')), 1)
            ], 8, _hoisted_61)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_64, [
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("h1", _hoisted_68, _toDisplayString(_ctx.$t('linkValidationLevel2.transactionDetails')), 1),
              _cache[15] || (_cache[15] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('linkValidationLevel2.transactionCode')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((transaction.value.payoutId) = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, transaction.value.payoutId]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('linkValidationLevel2.phone')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((transaction.value.contact) = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, transaction.value.contact]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('linkValidationLevel2.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((amount).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, amount.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('linkValidationLevel2.date')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((transaction.value.transactionDate) = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, transaction.value.transactionDate]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('linkValidationLevel2.operator')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((operator).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, operator.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t('linkValidationLevel2.status')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((paymentStatus).value = $event)),
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, paymentStatus.value]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})